import { Utils } from 'choerodon-ui/dataset';
const getNearStepValues = Utils.getNearStepValues;
const getPrecision = Utils.getPrecision;
const MAX_SAFE_INTEGER = Utils.MAX_SAFE_INTEGER;
const MIN_SAFE_INTEGER = Utils.MIN_SAFE_INTEGER;
const plus = Utils.plus;
const parseNumber = Utils.parseNumber;
const bigNumberToFixed = Utils.bigNumberToFixed;
const parseBigNumber = Utils.parseBigNumber;
export { MAX_SAFE_INTEGER, MIN_SAFE_INTEGER, getNearStepValues, getPrecision, plus, parseNumber, bigNumberToFixed, parseBigNumber, };
